
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductSizeMasterDialog extends Serenity.EntityDialog<ProductSizeMasterRow, any> {
        protected getFormKey() { return ProductSizeMasterForm.formKey; }
        protected getIdProperty() { return ProductSizeMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSizeMasterRow.localTextPrefix; }
        protected getNameProperty() { return ProductSizeMasterRow.nameProperty; }
        protected getService() { return ProductSizeMasterService.baseUrl; }
        protected getDeletePermission() { return ProductSizeMasterRow.deletePermission; }
        protected getInsertPermission() { return ProductSizeMasterRow.insertPermission; }
        protected getUpdatePermission() { return ProductSizeMasterRow.updatePermission; }

        protected form = new ProductSizeMasterForm(this.idPrefix);

        constructor() {
            super();

            q.setTextRightAlign(this.form.CM);
            q.setTextRightAlign(this.form.MM);
            q.setTextRightAlign(this.form.INCH);


            this.form.MM.changeSelect2(e => {

                this.form.CM.value = this.form.MM.value / 10;
                this.form.INCH.value = this.form.MM.value / 25.4;

            });

            this.form.CM.changeSelect2(e => {

                this.form.MM.value = this.form.CM.value * 10;
                this.form.INCH.value = this.form.CM.value / 2.54;

            });

            this.form.INCH.changeSelect2(e => {

                this.form.CM.value = this.form.INCH.value * 2.54;
                this.form.MM.value = this.form.INCH.value * 25.4;

            });


        }


    }
}